import VerifyTokenCard from './verifyTokenCard'

export default VerifyTokenCard